<template>
  <div class="leave-tab-sections">
    <UnplannedLeaveSection />
    <PlannedLeaveSection />
  </div>
</template>

<script>
import UnplannedLeaveSection from "./UnplannedLeaveSection.vue";
import PlannedLeaveSection from "./PlannedLeaveSection.vue";

export default {
  name: "LeaveTab",
  components: {
    UnplannedLeaveSection,
    PlannedLeaveSection,
  },
};
</script>

<style lang="scss" scoped>
.leave-tab-sections > * {
  margin-bottom: 1rem;
}
</style>
<style lang="scss">
.current-percentage {
  margin-left: 1rem;
  margin-top: 1rem;
  color: var(--color-eerie-black-60);

  .current-percentage-value {
    margin-left: 1.5rem;
  }
}

.current-percentage {
  padding-bottom: 1rem;
}

.edit-row .decimal-input {
  width: 7em;
}
</style>
